import React from "react";

import { ListItemText, ListItemIcon, MenuItem, Tooltip } from "@material-ui/core";
import { People, Link, Settings, Help } from "@material-ui/icons";
import classNames from "classnames";

import { IOrg } from "@schema";
import { AllAppNavViews, AppNavModal, AppNavPageView } from "./ClockwiseHome";

import Sidebar from "@clockwise/web-commons/src/ui/layouts/Sidebar";
import { AdminPanelSettingsIcon } from "@img/icons";
import { paths } from "@clockwise/client-commons/src/constants/site";
import { baseUrl } from "@clockwise/client-commons/src/constants/help-center";
interface IAdminPanelSidebarProps {
  org?: IOrg;
  currentPageView: AppNavPageView;
  currentModalView: AppNavModal;
  onSelectView: (view: AllAppNavViews) => void;
}

const iconByView = {
  "one-on-ones": <People className="cw-fill-gray-500" />,
  "scheduling-links": <Link className="cw-fill-gray-500" />,
  settings: <Settings className="cw-fill-gray-500" />,
  "help-center": <Help className="cw-fill-gray-500" />,
  "admin-panel": <AdminPanelSettingsIcon />,
};

export default function ClockwiseHomeSidebar({
  currentPageView,
  currentModalView,
  onSelectView,
}: IAdminPanelSidebarProps) {
  const handleMenuItemClick = (selectedView: AllAppNavViews) => {
    onSelectView(selectedView);
  };

  const menuItemClasses = "cw-min-h-[60px]";
  const currentViewClasses = "cw-bg-gray-300";

  const isActivePageView = (pageView: AppNavPageView): boolean => {
    return currentPageView === pageView && !currentModalView;
  };

  const isActiveModalView = (modalView: AppNavModal): boolean => {
    return modalView === currentModalView;
  };

  const OneOnOnes = () => {
    return (
      <Tooltip className="cw-text-base" title={"One-on-Ones"} placement={"right"} key="one-on-ones">
        <MenuItem
          onClick={() => {
            handleMenuItemClick("one-on-ones");
          }}
          className={classNames([
            menuItemClasses,
            { [currentViewClasses]: isActivePageView("one-on-ones") },
          ])}
        >
          <ListItemIcon>{iconByView["one-on-ones"]}</ListItemIcon>
          <ListItemText inset primary={"One-on-Ones"} />
        </MenuItem>
      </Tooltip>
    );
  };

  const SchedulingLinks = () => {
    return (
      <Tooltip title={"Scheduling Links"} placement={"right"} key="scheduling-links">
        <MenuItem
          key="scheduling-links"
          onClick={() => {
            handleMenuItemClick("scheduling-links");
          }}
          className={classNames([
            menuItemClasses,
            { [currentViewClasses]: isActivePageView("scheduling-links") },
          ])}
        >
          <ListItemIcon>{iconByView["scheduling-links"]}</ListItemIcon>
          <ListItemText inset primary="Scheduling Links" />
        </MenuItem>
      </Tooltip>
    );
  };

  const Settings = () => {
    return (
      <Tooltip title={"Settings"} placement={"right"} key="settings">
        <MenuItem
          onClick={() => {
            handleMenuItemClick("settings");
          }}
          className={classNames([
            menuItemClasses,
            { [currentViewClasses]: isActiveModalView("settings") },
          ])}
        >
          <ListItemIcon>{iconByView["settings"]}</ListItemIcon>
          <ListItemText inset primary="Settings" />
        </MenuItem>
      </Tooltip>
    );
  };

  const HelpCenter = () => {
    return (
      <Tooltip title={"Help Center"} placement={"right"} key="help-center">
        <MenuItem
          className={classNames([menuItemClasses])}
          onClick={() => {
            window.open(baseUrl, "_blank");
          }}
        >
          <ListItemIcon>{iconByView["help-center"]}</ListItemIcon>
          <ListItemText inset primary="Help Center" />
        </MenuItem>
      </Tooltip>
    );
  };

  const AdminPanel = () => {
    return (
      <Tooltip title={"Admin Panel"} placement={"right"} key="admin-panel">
        <MenuItem
          onClick={() => {
            window.open(paths.admin, "_blank");
          }}
          className={classNames([menuItemClasses])}
        >
          <ListItemIcon>{iconByView["admin-panel"]}</ListItemIcon>
          <ListItemText inset primary="Admin Panel" />
        </MenuItem>
      </Tooltip>
    );
  };

  return (
    <Sidebar
      menuItems={[<OneOnOnes />, <SchedulingLinks />, <Settings />]}
      footerItems={[<HelpCenter />, <AdminPanel />]}
    />
  );
}
